import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {switchMap, tap} from "rxjs/operators";
import {SchoolStudentsEstimate, SchoolStudentStats, V3School} from "../../../model/v3/schools";
import {SchoolV3RestService} from "../../../services/rest/v3/school-rest.service";


@Component({
    selector: 'app-students-summary-block',
    templateUrl: './students-summary-block.component.html',
    styleUrls: ['./students-summary-block.component.css'],
    standalone: false
})
export class StudentsSummaryBlockComponent implements OnInit {
  stats: SchoolStudentStats;
  schoolEstimates: SchoolStudentsEstimate
  @Input()
  set school(value: V3School) {
    this.mSchool = value;
    this.reload();
  }

  @Output() redirectEmitter: EventEmitter<string> = new EventEmitter();
  mSchool: V3School;

  constructor(private schoolV3Rest: SchoolV3RestService) {}

  ngOnInit() {
  }

  private reload() {
    if (!this.mSchool) return;

    this.schoolV3Rest.getSchoolStudentStats(this.mSchool.id).pipe(
      tap(stats => this.stats = stats),
      switchMap(_ => this.schoolV3Rest.getSchoolEstimates(this.mSchool.id)),
      tap(estimates => this.schoolEstimates = estimates)
    ).subscribe()

  }

  getActive() {
    return this.schoolEstimates?.active;
  }

  getNew() {
    return this.stats.newStudents;
  }

  getRenewed() {
    return this.stats.prolongs;
  }

  getBlocked() {
    return this.stats.deactivations;
  }

  getDeleted() {
    return this.stats.deletions;
  }

  getUnblocked() {
    return this.stats.activations - this.stats.newStudents;
  }

  isReady() {
    return this.mSchool && this.stats;
  }

  getTotal() {
    return this.schoolEstimates?.total;
  }

  redirectTo(path: string) {
    this.redirectEmitter.emit(path);
  }
}
